{
  "title": "Contact Other Plane",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level divination (ritual)",
  "level": 5,
  "castingTime": "1 minute",
  "range": "Self",
  "components": "V",
  "duration": "1 minute",
  "description": [
    "You mentally contact a demigod, the spirit of a long-dead sage, or some other mysterious entity from another plane. Contacting this extraplanar intelligence can strain or even break your mind. When you cast this spell, make a DC 15 Intelligence saving throw. On a failure, you take 6d6 psychic damage and are insane until you finish a long rest. While insane, you can’t take actions, can’t understand what other creatures say, can’t read, and speak only in gibberish. A Greater Restoration spell cast on you ends this effect.",
    "On a successful save, you can ask the entity up to five questions. You must ask your questions before the spell ends. The DM answers each question with one word, such as \"yes,\" \"no,\" \"maybe,\" \"never,\" \"irrelevant,\" or \"unclear\" (if the entity doesn’t know the answer to the question). If a one-word answer would be misleading, the DM might instead offer a short phrase as an answer."
  ],
  "spellLists": ["warlock", "wizard"]
}
